import PropTypes from 'prop-types';
import Moment from 'moment';

const DateFromNow = props => {
    const { date } = props;

    Moment.updateLocale('en', {
        relativeTime: {
            future: diff => (diff == 'just now' ? diff : `in ${diff}`),
            past: diff => (diff == 'just now' ? diff : `${diff} ago`),
            s: 'just now',
            ss: 'just now'
        }
    });

    const utcFormat = Moment.utc(date).format();

    const d = Moment.utc(utcFormat)
        .local()
        .fromNow();

    return d;
};

DateFromNow.propTypes = {
    date: PropTypes.string
};

export default DateFromNow;
